import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

import { clientConfig } from 'config/client';

import { App } from './App';
import './index.styl';
import * as serviceWorker from './serviceWorker';

TagManager.initialize({
  gtmId: clientConfig.GOOGLE_TAG_MANAGER_ID,
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
